import OnboardingTopics from './OnboardingTopics'

export default OnboardingTopics
// eslint-disable-next-line import/export
export * from './OnboardingTopics'
